<template>
  <div>
    <p class="mb-10" style="text-align: center; font-size: 14px; color: #db2721">
      #neoinvestingadvice
    </p>
    <p style="text-align: center; font-size: 18px; ">
      Anmeldung läuft
    </p>
    <p style="text-align: center; font-size: 18px; ">
      Bitte um etwas Geduld
    </p>
  </div>
</template>

<script>

export default {
  name: 'FinSocialMediaSignInInProgress',
  components: {},
  props: {},
  data() {
    return {}
  },
  methods: {}
}

</script>


<style lang="scss" scoped>
</style>
